{
  "page_title": "Library",
  "heading": "Your plans",
  "heading_workspace": "{{name}} plans",
  "workspace_tabs": {
    "aria_label": "Workspaces",
    "selector_aria_label": "Workspace: {{name}}, {{descriptor}}",
    "personal": "Personal",
    "family": "Family",
    "business": "Organization"
  },
  "workspace_error": {
    "message": "We couldn't load this workspace.",
    "retry": "Try again",
    "personal": "Go to personal library"
  },
  "error_toast": "Error creating schedule",
  "more": "More",
  "rename_action": "Rename",
  "unfollow_action": "Unfollow",
  "delete_action": "Delete",
  "leave_action": "Leave",
  "collaborative_calendar": "Collaborative Calendar",
  "availability_calendar": "Availability Form",
  "conflict_calendar": "Conflict Form",
  "events_page": "Page",
  "printable": "Printable",
  "planner": "Planner",
  "unfollow_confirmation": {
    "title": "Unfollow {{title}}?",
    "message": "{{title}} will be removed from your list of schedules.",
    "submit": "Yes, unfollow"
  },
  "delete_confirmation": {
    "title": "Delete {{title}}?",
    "message": "",
    "submit": "Yes, delete"
  },
  "leave_confirmation": {
    "title": "Leave {{title}}?",
    "message": "",
    "submit": "Yes, leave"
  },
  "rename_modal": {
    "title": "Rename",
    "label": "Name",
    "placeholder": "Enter a name",
    "required": "Name is required",
    "cancel": "Cancel",
    "submit": "Rename"
  },
  "empty_state": {
    "title": "Imagine all the possibilities",
    "button": "Create new"
  },
  "rename_success_toast": "Renamed",
  "rename_error_toast": "Error renaming",
  "unfollow_success_toast": "Schedule unfollowed",
  "unfollow_error_toast": "Error unfollowing schedule",
  "unfollow_experience_success_toast": "Page unfollowed",
  "unfollow_experience_error_toast": "Error unfollowing page",
  "delete_success_toast": "Schedule deleted",
  "delete_error_toast": "Error deleting schedule",
  "delete_experience_success_toast": "Page deleted",
  "delete_experience_error_toast": "Error deleting page",
  "delete_printable_success_toast": "Printable deleted",
  "delete_printable_error_toast": "Error deleting printable",
  "leave_experience_success_toast": "Page removed",
  "leave_experience_error_toast": "Error leaving page",
  "leave_schedule_success_toast": "Schedule removed",
  "leave_schedule_error_toast": "Error leaving schedule",
  "last_opened": "Last opened {{date}}",
  "layout_toggle": {
    "card": "Card view",
    "table": "Table view"
  },
  "table": {
    "title": "Name",
    "type": "Type",
    "last_opened": "Last opened",
    "collaborators": "Collaborators"
  },
  "create_new": {
    "title": "Create new",
    "description": "Planner, printable, or page",
    "modal_title": "What would you like to create?",
    "planner": {
      "title": "Planner",
      "description": "Build a schedule, routine, or goal tracker.",
      "action": "Choose planner"
    },
    "printable": {
      "title": "Printable",
      "description": "Make a polished PDF to print and share.",
      "action": "Choose printable"
    },
    "page": {
      "title": "Page",
      "description": "Publish a beautiful page with a link.",
      "action": "Choose page"
    },
    "more": "More",
    "legacy": {
      "CLASSIC": {
        "title": "Make a Collaborative Calendar",
        "description": "Work together on a shared calendar"
      },
      "AVAILABILITY": {
        "title": "Availability Form",
        "description": "See who's available before you schedule"
      },
      "CONFLICT": {
        "title": "Conflict Form",
        "description": "Collect cast conflicts to plan your rehearsals"
      }
    },
    "add_to_calendar": "Need calendar events instead? Use Add to calendar above."
  }
}
